import script from "./BestIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./BestIndicator.vue?vue&type=script&setup=true&lang=js"

import "./BestIndicator.vue?vue&type=style&index=0&id=005182e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-005182e9"]])

export default __exports__